module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor24-3b0115009d7a0417c83cb9aec66b52c0.jpg";